module.exports = __webpack_public_path__ + "static/fonts/Arial-Bold-Italic.f04bc834.ttf";